import React, { Component } from 'react'
import { connect } from 'react-redux'
import Loader from 'components/loader/loader'

import ValidateResponse from 'components/validations/validate-response'
import withValidateResponse from 'components/validations/withValidateResponse'

import InputStandard from 'components/input/standard'

import SmoothCollapse from 'react-smooth-collapse'

import { 
	getUserRoles,  
	isPremium,
	getCurrentAccount,
} from 'state/selectors'

import {
	getMeta
} from 'utils'

import {
	updateStaffMember
} from 'state/actions'

import FeatureSelector from 'components/feature-selector/feature-selector'

import Button from 'components/button/button'

class EditStaffMember extends Component {
	state = {
		is_team: true,
		is_pm: false,
		is_admin: false,
		isLoading: false,
		role: '',
		hours_worked: 38
	}

	componentWillMount(){
		const { 
			roles,
			userData,
			accountData
		} = this.props

		const role = getMeta(userData, 'role', accountData)
		const hoursWorked = getMeta(userData, 'hoursWorked', accountData)

		this.setState({
			is_team: (!roles.pm && !roles.admin),
			is_pm: roles.pm,
			is_admin: roles.admin,
			role,
			hours_worked: hoursWorked
		})
	}

	togglePrivileges = role => {
		const newState = {
			is_team: false,
			is_pm: false,
			is_admin: false
		}

		newState[role.key] = true

		this.setState(newState)
	}

	handleChange = (value, key) => {
		this.setState({
			[key]: value
		})
	}

	handleSubmit = _ => {
		const { 
			userData,
			updateStaffMember,
			handleSuccess,
		} = this.props

		const {
			is_admin,
			is_pm,
			role,
			hours_worked
		} = this.state

		let roleLevel = 'team'

		if(is_pm){
			roleLevel = 'pm'
		}

		if(is_admin){
			roleLevel = 'admin'
		}

		this.setState({
			isLoading: true
		})

		const data = {
			roleLevel,
			role,
			hours_worked
		}

		updateStaffMember(userData, data, _ => {
			this.setState({
				isLoading: false
			})

			handleSuccess(`${userData.first_name}'s details have been updated`)
		})
	}

	render() {
		const {
			closeCallback,
			isPremium,
			accountData,
			validateResponse,
			handleDismiss,
			userData
		} = this.props

		const {
			isLoading,
			role,
			hours_worked
		} = this.state

		const rolesList = isPremium ? 
			[
				{
					title: 'Team Member',
					body: 'Read & write access to assigned & public projects.',
					key: 'is_team'
				},{
					title: 'Project Manager',
					body: 'Create, edit & assign teams, as well as all projects.',
					key: 'is_pm'
				},{
					title: 'Administrator',
					body: `Access account & billing settings, and modify team privileges.`,
					key: 'is_admin'
				}
			]
			:
			[
				{
					title: 'Team Member',
					body: 'Read & write access to all projects, and invite guests.',
					key: 'is_team'
				},{
					title: 'Administrator',
					body: `Access account & billing settings, and edit other team members.`,
					key: 'is_admin'
				}
			]

		return (
			<div className="auth-fields">
				<div className="modal-new-project">
					<Loader visible={isLoading} />
					<div>
						<div className="new-project-left input-wrap">
							<label>
								{ `${userData.first_name}'s role at ${accountData.name}:` }
							</label>
							<InputStandard 
								outlineOnFocus={true} 
								ref="roleName" 
								callback={null} 
								value={role} 
								onChange={e => {this.handleChange(e.target.value, 'role')}} 
								placeholder={`What's ${userData.first_name}'s role?`}
							/>
							{ isPremium &&
								<div className="hours-worked">
									<label>
										How many hours do they work a week?
									</label>
									<InputStandard 
										outlineOnFocus={true} 
										ref="hoursWorked" 
										callback={null} 
										value={hours_worked} 
										onChange={e => {this.handleChange(e.target.value, 'hours_worked')}} 
										placeholder="38" 
									/>
								</div>
							}
						</div>
						<div className="new-project-right input-wrap">
							<FeatureSelector
								featureList={rolesList}
								featureState={this.state}
								toggleCallback={this.togglePrivileges}
								canSelect={true}
							/>
						</div>
					</div>
				</div>
				<SmoothCollapse expanded={!!validateResponse}>
					<ValidateResponse 
						dismissCallback={handleDismiss} 
						response={validateResponse} 
						timeout={5000} 
						isAtTop={true}
					/>
				</SmoothCollapse>
				<Button 
					size={'big'} 
					level={'high'} 
					callback={this.handleSubmit} 
					label={'Update privileges'} 
					icon={'check'} 
				/>
				<Button 
					size={'big'} 
					level={'low'} 
					callback={closeCallback} 
					label={'Cancel'} 
				/>
			</div>
		)
	}
}

function mapStateToProps(state, ownProps) {
	return {
		roles: getUserRoles(state, ownProps.userData ),
		isPremium: isPremium(state),
		accountData: getCurrentAccount(state)
	}
}

const EditStaffMemberWithValidation = withValidateResponse(EditStaffMember)

export default connect(mapStateToProps, { updateStaffMember })(EditStaffMemberWithValidation)


// WEBPACK FOOTER //
// ./src/components/auth/edit-staff-member.jsx